import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { setSectionOptions } from '../store/options.actions'
import { OptionsService } from '../services/options.service'

export function* setSectionsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const sectionsOptionsResponse: IOptionsResponse = yield call([optionsService, optionsService.getSectionsOptions])
    const { entity } = sectionsOptionsResponse

    yield put(setSectionOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setSectionsOptions() error: ${e}`))
  }
}

export function* setSectionsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setSectionsOptions)
}
